import axios from "axios";
import JSZip from "jszip";
import {saveAs} from "file-saver";
import {v4 as uuid} from "uuid";
import stores from "@/common/utils/stores.js";
import Fingerprint2 from "fingerprintjs2";
import request from "@/services/index.jsx";
import isEmpty from "lodash/isEmpty";
import {message} from "antd";
import CryptoJS from 'crypto-js';
// 生成nanoid

// 格式化日期时间
export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const listRequest = async (api, params, sort, fieldMap) => {
    const _params = {
        ...params,
        pageNum: params.current,
    };
    if (!isEmpty(sort) && fieldMap) {
        Object.keys(sort).map((s) => {
            _params.sortField = fieldMap[s];
            _params.sortType = sort[s] === "ascend" ? "ASC" : "DESC";
        });
    }
    const res = await request.get(api, _params);
    return {
        success: res.success,
        message: res.message,
        total: res.data?.total ?? 0,
        data: res.data?.list ?? [],
    };
};

let urlAlphabet =
    "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";

export const nanoid = (size = 21) => {
    let id = "";
    let i = size;
    while (i--) {
        id += urlAlphabet[(Math.random() * 64) | 0];
    }
    return "client-" + id;
};

export const batchDownloadAndZipFile = async (propUrls, name, isBlob) => {
    let resList;
    if (isBlob) {
        resList = propUrls;
    } else {
        const urls = propUrls
            .filter((t) => !!t)
            .map((t) => {
                return isOssKey(t) ? getOssRedirectUrl(t, true) : t;
            });

        if (!urls.length) return;

        resList = await Promise.all(
            urls.map((url) => {
                return axios
                    .get(url, {
                        responseType: "blob",
                    })
                    .then((t) => t.data);
            })
        );
    }

    const zip = new JSZip();
    resList.forEach((blob) => {
        let name = uuid();
        if (!name.includes(".")) {
            const ext = blobImageTypeMap[blob.type];
            if (ext) {
                name += "." + ext;
            }
        }
        zip.file(name, blob, {binary: true});
    });
    zip
        .generateAsync({
            type: "blob",
            compression: "STORE",
        })
        .then((res) => {
            saveAs(res, name || `kerqu-ai-image-${Date.now()}.zip`);
        });
};

export const fileToDataUrl = (file) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        const reader = new FileReader();
        reader.onload = function (e) {
            img.src = e.target.result;
        };
        reader.onerror = function (e) {
            reject(e);
        };
        reader.readAsDataURL(file);
        img.onload = function () {
            resolve(img.src);
        };
        img.onerror = function (e) {
            reject(e);
        };
    });
};

export const getOssRedirectUrl = (ossKey, isOriginal) => {
    return `/api/oss/downloadImage?ossKey=${ossKey}&originalImage=${isOriginal}`
}

export const isOssKey = (url) => {
    if (!url || typeof url !== "string") return false;
    return (
        url.startsWith(import.meta.env.VITE_PUBLIC_OSS_HOST) ||
        url.startsWith("temp/") ||
        url.startsWith("/temp/") ||
        url.startsWith("group/") ||
        url.startsWith("/group/") ||
        url.startsWith("image/") ||
        url.startsWith("/image/")
    );
};

export const getOssKey = (url) => {
    if (url.startsWith(import.meta.env.VITE_PUBLIC_OSS_HOST)) {
        let start = url.indexOf("/temp/");
        if (start == -1) {
            start = url.indexOf("/image/");
        }
        const end = url.indexOf("?");
        return url.substring(start + 1, end);
    } else if (url.startsWith("temp/")) {
        return url;
    } else if (url.startsWith("/temp/")) {
        return url.substring(1);
    } else if (url.startsWith("group/")) {
        return url;
    } else if (url.startsWith("/group/")) {
        return url.substring(1);
    }
    throw new Error("invalid oss key");
};

const blobImageTypeMap = {
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/webp": "webp",
};

/**
 * 获取浏览器WebGl指纹
 */
export function getWebGlFingerprint() {
    // 创建一个canvas元素
    var canvas = document.createElement("canvas");
    // 获取WebGL上下文
    var gl =
        canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
    if (!gl) {
        console.log("WebGL is not supported");
        return "";
    } else {
        // 生成一个包含WebGL信息的指纹
        var extension = gl.getExtension("WEBGL_debug_renderer_info");
        var renderer = gl.getParameter(extension.UNMASKED_RENDERER_WEBGL);
        return renderer;
    }
}

/**
 * 获取浏览器canvansID
 * @returns
 */
export function getCanvasFingerprint() {
    // 创建一个canvas元素
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");

    // 设置canvas的特定属性
    canvas.width = 1;
    canvas.height = 1;
    ctx.textBaseline = "alphabetic";
    ctx.fillStyle = "#f60";
    ctx.fillRect(125, 1, 62, 20);

    // 生成Canvas指纹
    var canvasFingerprint = canvas.toDataURL();

    return canvasFingerprint || "";
}

// 获取浏览器指纹
export function setBroswerFingerprint() {
    try {
        setTimeout(() => {
            Fingerprint2.get((components) => {
                // 参数只有回调函数时，默认浏览器指纹依据所有配置信息进行生成
                const webgl =
                    components.find((item) => item.key === "webgl")?.value || [];
                const canvas =
                    components.find((item) => item.key === "canvas")?.value || [];
                const webglID = Fingerprint2.x64hash128(webgl.join(""), 31); // 生成webGLid
                const canvaslID = Fingerprint2.x64hash128(canvas.join(""), 31); // 生成canvansId
                stores.saveLocalStorage("webglId", webglID || "");
                stores.saveLocalStorage("canvaslId", canvaslID || "");
            });
        }, 1000);
    } catch (e) {
        console.log(e);
    }
}

/**
 * 生成基于浏览器指纹的32位16进制硬件唯一key
 * 用于图片验证码等需要设备唯一标识的场景
 * @returns {string} 32位16进制字符串
 */
export function generateHardwareKey() {
  // 获取已存储的浏览器指纹
  let canvasId = stores.getLocalStorage("canvaslId");
  let webglId = stores.getLocalStorage("webglId");
  
  // 如果指纹不存在，使用备用方案
  if (!canvasId) {
    let uuid_key = stores.getLocalStorage("canvaslId-uuid");
    if (!uuid_key) {
      uuid_key = uuid();
      stores.saveLocalStorage("canvaslId-uuid", uuid_key);
    }
    canvasId = uuid_key;
  }
  
  if (!webglId) {
    webglId = "default-webgl-" + Date.now();
  }
  
  // 合并指纹数据
  const combinedFingerprint = canvasId + webglId;
  
  // 使用CryptoJS进行SHA256哈希，然后截取前32位
  const hash = CryptoJS.SHA256(combinedFingerprint).toString();
  
  // 返回前32位16进制字符串
  return hash.substring(0, 32);
}

/**
 * 使用 栈的 方案 遍历 树形 数据
 * @param tree
 * @param options  参数
 * */
export function ergodicTree(
    tree = [],
    {
        childName = 'child',
        direction = 'l-dfs',
        itemCallBack = () => {
        },
        autoAddParentId = false // 是否自动添加 parentId
    } = {}
) {

    if (['l-dfs', 'r-dfs', 'l-bfs', 'r-bfs'].indexOf(direction) === -1) {
        console.log(new Error('传入的遍历方向不对,参考:\'l-dfs\',\'r-dfs\',\'l-bfs\',\'r-bfs\''))
        return
    }

    let _status = true // 存储是否继续进行遍历的 一个 状态开关
    let _stack = [] // 存放栈 数据

    tree.forEach(item => { // 将 第一次数据放到对应的栈里面
        if (direction === 'l-dfs' || direction === 'r-bfs') { // 左 子节点深度遍历 和 右 子节点 广度遍历
            _stack.unshift(item)
        } else if (direction === 'r-dfs' || direction === 'l-bfs') { // 右 子节点深度遍历 和 左 子节点 广度遍历
            _stack.push(item)
        }
    })

    // 检查 栈是否为空，和 当前 遍历状态是否 可用，如果 栈 被清空，说明没有可以便利的数据
    while (_stack.length && _status !== false) {
        let _stackTop // 取出栈顶 元素
        if (direction === 'l-bfs' || direction === 'r-bfs') { // 左 子节点  和 右 子节点 广度遍历
            _stackTop = _stack.shift()
        } else { // 右 子节点深度遍历 和 左 子节点 广度遍历
            _stackTop = _stack.pop()
        }

        // 把这个元素 回调回去, 根据 _status 确定 是否 还继续 向下 遍历
        _status = itemCallBack(_stackTop)

        if (_stackTop[childName] && _stackTop[childName].length) { // 检查栈顶元素是否还有子节点

            let _child = []
            if (direction === 'l-dfs' || direction === 'r-bfs') { // 左 子节点 深度  和 右 子节点 广度遍历
                _child = _stackTop[childName].reverse() // 因为是左叶子节点深度遍历，所以需要对自己点翻转
            } else if (direction === 'r-dfs' || direction === 'l-bfs') { // 右 子节点 深度  和 左 子节点 广度遍历
                _child = _stackTop[childName]
            }

            if (autoAddParentId) {
                // 添加 parentId
                _child.forEach(_item => {
                    _item.parentId = _stackTop.id
                })
            }

            _stack = _stack.concat(_child) // 如果有子节点，那么将子节点放在栈里面

        }

    }
}

/**
 * 根据 对象列表里面的 某个参数 去重
 * */
export function delRepeatData(list, key) {
  const keyList = [];

  return list.filter(item => {
    const noExit = keyList.indexOf(item[key]) === -1;
    if(noExit){
      keyList.push(item[key]);
    }
    return noExit
  })

}

export const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export const copyToClipboard = (text) => {
  if (navigator.clipboard) {
    return navigator.clipboard.writeText(text).then(() => {
      message.success('复制成功');
    }).catch(err => {
      console.error('复制失败:', err);
      message.error('复制失败');
    });
  } else {
    // 兼容旧浏览器
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        message.success('复制成功');
      } else {
        message.error('复制失败');
      }
    } catch (err) {
      console.error('复制失败:', err);
      message.error('复制失败');
    }
    document.body.removeChild(textArea);
  }
};

/**
 * 动态 z-index 管理工具
 */
class ZIndexManager {
  constructor() {
    this.baseZIndex = 1000; // 基础 z-index
    this.currentMaxZIndex = this.baseZIndex;
  }

  /**
   * 获取当前页面中最高的 z-index 值
   * @returns {number} 最高的 z-index 值
   */
  getCurrentMaxZIndex() {
    let maxZIndex = this.baseZIndex;
    
    // 获取所有可见元素
    const allElements = document.querySelectorAll('*');
    
    for (let element of allElements) {
      const computedStyle = window.getComputedStyle(element);
      const zIndex = parseInt(computedStyle.zIndex);
      
      // 只考虑有效的 z-index 值
      if (!isNaN(zIndex) && zIndex > maxZIndex) {
        maxZIndex = zIndex;
      }
    }
    
    // 检查 Antd 组件的常见 z-index 值
    const antdSelectors = [
      '.ant-modal-wrap',
      '.ant-modal',
      '.ant-drawer',
      '.ant-tooltip',
      '.ant-popover',
      '.ant-dropdown',
      '.ant-select-dropdown',
      '.ant-picker-dropdown',
      '.ant-image-preview-wrap',
      '.ant-message',
      '.ant-notification'
    ];
    
    antdSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        const computedStyle = window.getComputedStyle(element);
        const zIndex = parseInt(computedStyle.zIndex);
        if (!isNaN(zIndex) && zIndex > maxZIndex) {
          maxZIndex = zIndex;
        }
      });
    });
    
    this.currentMaxZIndex = maxZIndex;
    return maxZIndex;
  }

  /**
   * 获取下一个可用的 z-index 值
   * @param {number} increment 增量，默认为 100
   * @returns {number} 新的 z-index 值
   */
  getNextZIndex(increment = 100) {
    const currentMax = this.getCurrentMaxZIndex();
    const nextZIndex = currentMax + increment;
    this.currentMaxZIndex = nextZIndex;
    return nextZIndex;
  }

  /**
   * 为特定元素获取合适的 z-index
   * @param {HTMLElement} element 目标元素
   * @param {number} increment 增量
   * @returns {number} 计算出的 z-index 值
   */
  getZIndexForElement(element, increment = 100) {
    // 如果元素有父级 Modal 或容器，基于其 z-index 计算
    let parentZIndex = this.baseZIndex;
    
    let parent = element.parentElement;
    while (parent && parent !== document.body) {
      const computedStyle = window.getComputedStyle(parent);
      const zIndex = parseInt(computedStyle.zIndex);
      
      if (!isNaN(zIndex) && zIndex > parentZIndex) {
        parentZIndex = zIndex;
        break;
      }
      
      parent = parent.parentElement;
    }
    
    // 如果找到了父级的 z-index，基于它计算；否则基于全局最大值
    if (parentZIndex > this.baseZIndex) {
      return parentZIndex + increment;
    } else {
      return this.getNextZIndex(increment);
    }
  }

  /**
   * 为图片预览获取合适的 z-index
   * @param {HTMLElement} triggerElement 触发预览的元素
   * @returns {number} 预览的 z-index 值
   */
  getPreviewZIndex(triggerElement) {
    // 图片预览需要比所有现有元素都高，使用更大的增量
    const currentMax = this.getCurrentMaxZIndex();
    
    // 检查是否有其他预览组件正在显示
    const existingPreviews = document.querySelectorAll('.ant-image-preview-wrap');
    let maxPreviewZIndex = 0;
    
    existingPreviews.forEach(preview => {
      const zIndex = parseInt(window.getComputedStyle(preview).zIndex);
      if (!isNaN(zIndex) && zIndex > maxPreviewZIndex) {
        maxPreviewZIndex = zIndex;
      }
    });
    
    // 计算新的预览 z-index，确保比现有的预览和所有其他元素都高
    const baseZIndex = Math.max(currentMax, maxPreviewZIndex);
    return baseZIndex + 300; // 使用更大的增量确保预览始终在最顶层
  }

  /**
   * 获取图片预览的绝对最高 z-index
   * 这个方法专门用于确保图片预览始终显示在最顶层
   * @returns {number} 绝对最高的 z-index 值
   */
  getAbsoluteTopZIndex() {
    const currentMax = this.getCurrentMaxZIndex();
    
    // 检查所有可能的高 z-index 组件
    const highZIndexSelectors = [
      '.ant-image-preview-wrap',
      '.ant-modal-wrap',
      '.ant-drawer',
      '.ant-tooltip',
      '.ant-popover',
      '.ant-dropdown',
      '.ant-notification',
      '.ant-message'
    ];
    
    let absoluteMax = currentMax;
    
    highZIndexSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        const zIndex = parseInt(window.getComputedStyle(element).zIndex);
        if (!isNaN(zIndex) && zIndex > absoluteMax) {
          absoluteMax = zIndex;
        }
      });
    });
    
    // 返回比绝对最高值还要高的 z-index
    return absoluteMax + 500;
  }

  /**
   * 为 Modal 获取合适的 z-index
   * @param {HTMLElement} parentModal 父级 Modal 元素（可选）
   * @returns {number} Modal 的 z-index 值
   */
  getModalZIndex(parentModal = null) {
    if (parentModal) {
      const parentZIndex = parseInt(window.getComputedStyle(parentModal).zIndex) || this.baseZIndex;
      return parentZIndex + 100;
    } else {
      return this.getNextZIndex(100);
    }
  }

  /**
   * 重置 z-index 管理器
   */
  reset() {
    this.currentMaxZIndex = this.baseZIndex;
  }
}

// 创建全局实例
export const zIndexManager = new ZIndexManager();

/**
 * 获取动态 z-index 的便捷函数
 */
export const getDynamicZIndex = (increment = 100) => {
  return zIndexManager.getNextZIndex(increment);
};

/**
 * 为图片预览获取动态 z-index
 */
export const getPreviewZIndex = (triggerElement = null) => {
  if (triggerElement) {
    return zIndexManager.getPreviewZIndex(triggerElement);
  } else {
    // 如果没有触发元素，使用绝对最高的 z-index
    return zIndexManager.getAbsoluteTopZIndex();
  }
};

/**
 * 获取绝对最高的 z-index，用于确保元素显示在最顶层
 */
export const getAbsoluteTopZIndex = () => {
  return zIndexManager.getAbsoluteTopZIndex();
};

/**
 * 为 Modal 获取动态 z-index
 */
export const getModalZIndex = (parentModal = null) => {
  return zIndexManager.getModalZIndex(parentModal);
};

/**
 * 全局图片预览管理器
 * 确保图片预览始终显示在最顶层，不受嵌套层级影响
 */
class ImagePreviewManager {
  constructor() {
    this.activePreview = null;
    this.previewZIndex = 999999; // 使用一个非常高的基础 z-index
    this.setupGlobalStyles();
  }

  /**
   * 设置全局样式，确保预览组件样式正确
   */
  setupGlobalStyles() {
    if (typeof document === 'undefined') return;
    
    const styleId = 'image-preview-global-styles';
    if (document.getElementById(styleId)) return;
    
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .ant-image-preview-wrap {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
        z-index: ${this.previewZIndex} !important;
      }
      
      .ant-image-preview-mask {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
        z-index: ${this.previewZIndex - 1} !important;
      }
      
      .ant-image-preview {
        position: relative !important;
        z-index: ${this.previewZIndex + 1} !important;
      }
      
      .ant-image-preview-operations-wrapper,
      .ant-image-preview-switch-left,
      .ant-image-preview-switch-right {
        position: relative !important;
        z-index: ${this.previewZIndex + 2} !important;
      }
      
      .ant-image-preview-close {
        position: relative !important;
        z-index: ${this.previewZIndex + 3} !important;
      }
    `;
    document.head.appendChild(style);
  }

  /**
   * 获取当前最高的 z-index 并更新预览 z-index
   */
  updatePreviewZIndex() {
    const currentMax = zIndexManager.getCurrentMaxZIndex();
    this.previewZIndex = Math.max(999999, currentMax + 1000);
    this.updateGlobalStyles();
  }

  /**
   * 更新全局样式
   */
  updateGlobalStyles() {
    const style = document.getElementById('image-preview-global-styles');
    if (style) {
      const baseIndex = this.previewZIndex;
      style.textContent = `
        .ant-image-preview-wrap {
          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          width: 100vw !important;
          height: 100vh !important;
          z-index: ${baseIndex} !important;
        }
        
        .ant-image-preview-mask {
          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          width: 100vw !important;
          height: 100vh !important;
          z-index: ${baseIndex - 1} !important;
        }
        
        .ant-image-preview {
          position: relative !important;
          z-index: ${baseIndex + 1} !important;
        }
        
        .ant-image-preview-operations-wrapper,
        .ant-image-preview-switch-left,
        .ant-image-preview-switch-right {
          position: relative !important;
          z-index: ${baseIndex + 2} !important;
        }
        
        .ant-image-preview-close {
          position: relative !important;
          z-index: ${baseIndex + 3} !important;
        }
      `;
    }
  }

  /**
   * 强制设置预览组件的 z-index
   */
  forceSetPreviewZIndex() {
    this.updatePreviewZIndex();
    
    // 强制设置所有预览相关元素的样式
    const elements = [
      { selector: '.ant-image-preview-wrap', zIndex: this.previewZIndex },
      { selector: '.ant-image-preview-mask', zIndex: this.previewZIndex - 1 },
      { selector: '.ant-image-preview', zIndex: this.previewZIndex + 1 },
      { selector: '.ant-image-preview-operations-wrapper', zIndex: this.previewZIndex + 2 },
      { selector: '.ant-image-preview-switch-left', zIndex: this.previewZIndex + 2 },
      { selector: '.ant-image-preview-switch-right', zIndex: this.previewZIndex + 2 },
      { selector: '.ant-image-preview-close', zIndex: this.previewZIndex + 3 }
    ];

    elements.forEach(({ selector, zIndex }) => {
      const els = document.querySelectorAll(selector);
      els.forEach(el => {
        el.style.zIndex = zIndex;
        el.style.position = selector.includes('preview-wrap') || selector.includes('preview-mask') ? 'fixed' : 'relative';
        
        // 对于预览包装器和遮罩，确保覆盖整个视窗
        if (selector.includes('preview-wrap') || selector.includes('preview-mask')) {
          el.style.top = '0';
          el.style.left = '0';
          el.style.width = '100vw';
          el.style.height = '100vh';
        }
      });
    });
  }

  /**
   * 监听预览打开事件
   */
  onPreviewOpen() {
    this.activePreview = true;
    this.forceSetPreviewZIndex();
    
    // 持续监听并强制设置 z-index
    const interval = setInterval(() => {
      if (!this.activePreview) {
        clearInterval(interval);
        return;
      }
      this.forceSetPreviewZIndex();
    }, 100);
  }

  /**
   * 监听预览关闭事件
   */
  onPreviewClose() {
    this.activePreview = false;
  }
}

// 创建全局图片预览管理器实例
export const imagePreviewManager = new ImagePreviewManager();

// 导出便捷函数
export const handleImagePreviewOpen = () => {
  imagePreviewManager.onPreviewOpen();
};

export const handleImagePreviewClose = () => {
  imagePreviewManager.onPreviewClose();
};

// 格式化价格工具函数
export const formatPrice = (price) => {
  if (price === null || price === undefined || price === '') return '-';
  const numPrice = typeof price === 'string' ? parseFloat(price) : price;
  return isNaN(numPrice) ? '-' : `${numPrice.toFixed(2)}`;
};

// 增强的Modal蒙层处理 - 确保子Modal蒙层正确覆盖父Modal
export const applyModalMaskFix = (open, modalZIndex) => {
  if (open && modalZIndex) {
    setTimeout(() => {
      console.log(`🔍 开始蒙层修复: modalZIndex=${modalZIndex}`);
      
      // 查找所有Modal wrap元素
      const allModalWraps = document.querySelectorAll('.ant-modal-wrap');
      console.log(`📊 当前页面共有 ${allModalWraps.length} 个Modal`);
      
      // 显示所有Modal的层级信息
      allModalWraps.forEach((wrap, index) => {
        const modal = wrap.querySelector('.ant-modal');
        const mask = wrap.querySelector('.ant-modal-mask');
        const title = modal?.querySelector('.ant-modal-title')?.textContent || '无标题';
        const modalZIndex = window.getComputedStyle(modal || wrap).zIndex;
        const maskZIndex = mask ? window.getComputedStyle(mask).zIndex : '无蒙层';
        
        console.log(`📋 Modal${index + 1}: ${title} - Modal zIndex: ${modalZIndex}, 蒙层 zIndex: ${maskZIndex}`);
      });
      
      // 查找当前Modal的wrap元素
      const currentModal = Array.from(allModalWraps).find(wrap => {
        const modal = wrap.querySelector('.ant-modal');
        return modal && window.getComputedStyle(modal).zIndex == modalZIndex;
      });

      if (currentModal) {
        console.log(`✅ 找到目标Modal: zIndex=${modalZIndex}`);
        
        // 设置当前Modal wrap的z-index
        currentModal.style.zIndex = modalZIndex.toString();
        
        // 找到并设置蒙层的z-index
        const mask = currentModal.querySelector('.ant-modal-mask');
        if (mask) {
          // 蒙层z-index应该比子Modal低50，但比父Modal高
          const maskZIndex = modalZIndex - 50;
          
          console.log(`🎭 设置蒙层: 原zIndex=${window.getComputedStyle(mask).zIndex} → 新zIndex=${maskZIndex}`);
          
          mask.style.zIndex = maskZIndex.toString();
          mask.style.backgroundColor = 'rgba(0, 0, 0, 0.55)';
          mask.style.position = 'fixed';
          mask.style.top = '0';
          mask.style.left = '0';
          mask.style.width = '100vw';
          mask.style.height = '100vh';
          mask.style.pointerEvents = 'auto';
          
          // 验证设置结果
          setTimeout(() => {
            const finalMaskZIndex = window.getComputedStyle(mask).zIndex;
            console.log(`✔️ 蒙层设置完成: ${finalMaskZIndex}`);
          }, 10);
        } else {
          console.log(`❌ 未找到蒙层元素`);
        }

        // 设置Modal元素本身的z-index
        const modal = currentModal.querySelector('.ant-modal');
        if (modal) {
          modal.style.zIndex = modalZIndex.toString();
          console.log(`✔️ Modal元素设置完成: ${modalZIndex}`);
        }
      } else {
        console.log(`❌ 未找到目标Modal: zIndex=${modalZIndex}`);
      }
      
      // 再次检查所有Modal的最终状态
      setTimeout(() => {
        console.log(`🏁 最终状态检查:`);
        const finalModalWraps = document.querySelectorAll('.ant-modal-wrap');
        finalModalWraps.forEach((wrap, index) => {
          const modal = wrap.querySelector('.ant-modal');
          const mask = wrap.querySelector('.ant-modal-mask');
          const title = modal?.querySelector('.ant-modal-title')?.textContent || '无标题';
          const modalZIndex = window.getComputedStyle(modal || wrap).zIndex;
          const maskZIndex = mask ? window.getComputedStyle(mask).zIndex : '无蒙层';
          
          console.log(`🎯 最终Modal${index + 1}: ${title} - Modal zIndex: ${modalZIndex}, 蒙层 zIndex: ${maskZIndex}`);
        });
      }, 100);
      
    }, 50);
  }
};